import React from 'react';
import Textinput from './textinput';

import { isEveryValid, isLengthValid, firstError, scrollToError } from '../services/utils';

class FreightTypePopup extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.clearForm = this.clearForm.bind(this);

        this.initialState = {
            title: '',
            description: '',
            price: null,
            currency_id: 'USD',
            validation: {
                title: false,
                description: false
            },
            submitCliked: false
        }

        this.state = this.initialState;
        this.fetched = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != this.props){
            this.fillForm(nextProps);
        }
    }

    fillForm(props) {

        if (props.params && props.params.data && !this.fetched) {

            if ('data' in props.params) this.fetched = true;

            const { data } = props.params;
            this.setState({
                title: (props.params.mode=='update') ? data.title : '',
                description: data.description || '',
                price: data.price || null,
                currency_id: data.currency_id || 'USD',
                validation: {
                    title: !!props.params.data.title,
                    description: !!props.params.data.description
                }
            });
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;;

        let stateProps ={
            [name]: value
        };

        this.setState(stateProps, () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        if (this.state.validation[fieldName] != undefined) {
            value = isLengthValid(value, fieldName);
            this.setState({
                validation: {
                    ...this.state.validation,
                    [fieldName]: value ? true : false
                }
            });
        }
    }

    handleSubmit(mode, state, data) {
        const isValid = isEveryValid(this.state.validation);
        const errorField = firstError(this.state.validation);

        const updates = { ...data, ...state };
        const id = mode === 'update' ? { id: updates.id } : {};
        const freightData = {
            ...id,
            currency_id: updates.currency_id,
            title: updates.title,
            price: updates.price,
            description: updates.description,
        };

        this.setState({
            ...this.state,
            submitCliked: true,
        });

        if (isValid) {
            this.props.manageFreightType(
                mode,
                freightData,
                this.clearForm
            );
        } else {
            this.props.showPopup({
                title: 'Error',
                content: 'Please make sure all the information is correct and try again.',
                buttonText: 'Dismiss'
            });
            scrollToError(errorField, 'freight-popup-scroll-container');
        }
    }

    closePopup(e) {
        if (e.target.getAttribute('name') == 'freightTypePopup') {
            this.props.hidePopup();
            this.clearForm();
        }
    }


    clearForm() {
        this.setState(this.initialState);
        this.fetched = false;
    }

	render() {

        let { mode, name, data } = this.props.params;
        let { submitCliked } = this.state;

        return (
            <div
                onClick={ this.closePopup.bind(this) }
                style={{display: this.props.visible ? 'block' : 'none' }}
                name='freightTypePopup'
                className='admin-freight-container generic-popup-container'
                id='freight-popup-scroll-container'>
                  <div className='admin-freight-inner'>
                      <center>
                        <h2 className='title'>
                            {mode == 'create' ? 'Create' : 'Update'} freight
                        </h2>
                      </center>

                    <Textinput
                        label='Freight title'
                        name='title'
                        value={ this.state.title || '' }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={!this.state.validation.title && submitCliked}
                        type='text' />

                    <Textinput
                        label='Freight description'
                        name='description'
                        value={ this.state.description || '' }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={!this.state.validation.description && submitCliked}
                        type='text' />

                    <Textinput
                        label='Freight price'
                        name='price'
                        value={this.state.price}
                        onChange={this.handleChange}
                        type='number' />

                    <div className='field-wrap'>
                        <label htmlFor='currency_id' className='labelactive'>
                            Currency
                        </label>
                        <select name='currency_id' onChange={this.handleChange} value={this.state.currency_id}>
                            <option value='USD'>USD</option>
                            <option value='EUR'>EUR</option>
                            <option value='NOK'>NOK</option>
                            <option value='DKK'>DKK</option>
                        </select>
                    </div>

                      <button
                        onClick={this.handleSubmit.bind(this, mode, this.state, data)}
                        className='button button-block'>
                        {mode == 'create' ? 'Create' : 'Update'}
                      </button>
                  </div>
            </div>
        )
    }
}

export default FreightTypePopup;



// WEBPACK FOOTER //
// ./source/components/freightTypePopup.js